import { z } from 'zod/v4'

export const FilterSchema = z.object({
  // fullhandle of the field eg. model.field
  field: z.string(),
  operator: z.enum(['eq', 'ne', 'gt', 'gte', 'lt', 'lte']),
  value: z.string(),
})

const SortSchema = z.object({
  // fullhandle of the field eg. model.field
  field: z.string(),
  direction: z.enum(['asc', 'desc']),
})

const AggregateSchema = z.object({
  // fullhandle of the field eg. model.field
  field: z.string(),
  operator: z.enum(['sum', 'avg', 'min', 'max', 'count']),
})

export const QuerySchema = z
  .object({
    filters: z.array(FilterSchema),
    sort: SortSchema.optional(),
    aggregate: AggregateSchema.optional().nullable(),
  })
  .passthrough()

export type Query = z.infer<typeof QuerySchema>
